// components/Checkout.js

import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Checkout = () => {
  const { deliveryMethod, name, phone, address } = useSelector((state) => state.contact);
  const { totalPrice } = useSelector((state) => state.cart);
  const navigate = useNavigate();

  const handleProceedToPayment = () => {
    // Ensure payment is only possible if the user has selected delivery/pickup details
    if (deliveryMethod === 'delivery' && !address) {
      alert('Please provide a delivery address!');
    } else {
      navigate('/payment');
    }
  };

  return (
    <div className="container mx-auto py-12">
      <h2 className="text-3xl font-bold text-center mb-6">Checkout</h2>

      <div className="text-center mb-6">
        <p><strong>Delivery Method:</strong> {deliveryMethod === 'pick-up' ? 'Pick-up' : 'Delivery'}</p>
        <p><strong>Name:</strong> {name}</p>
        <p><strong>Phone:</strong> {phone}</p>
        {deliveryMethod === 'delivery' && <p><strong>Address:</strong> {address}</p>}
        <p><strong>Total: ₦{totalPrice.toLocaleString()}</strong></p>
      </div>

      <div className="text-center">
        <button
          onClick={handleProceedToPayment}
          className="px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          Proceed to Payment
        </button>
      </div>
    </div>
  );
};

export default Checkout;
